import { css } from 'lit';
export const styles = css `
:host(:focus){outline:0}
`;
//# sourceMappingURL=hds-accordion.css.js.map